<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="dialogClose" width="1000px">
    <el-form :model="form" label-width="130px" label-position="right" :rules="rules" ref="ruleForm" class="mt20">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="委托商：" prop="customerId" ref="customer">
            <el-select v-model="form.customerId" size="mini" filterable style="width: 100%" placeholder="请选择委托商" value-key="id" @change="customerChange">
              <el-option v-for="item in customerOptions" :key="item.id" :label="item.customer_name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="结算类型：" prop="settlementType">
            <el-select v-model="form.settlementType" size="mini" filterable style="width: 100%" placeholder="请选择结算类型" value-key="value" @change="emptySubordinates">
              <el-option v-for="item in settlementTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="港口/库房名称：" prop="nameId">
            <el-select v-model="form.nameId" size="mini" filterable style="width: 100%" placeholder="请选择港口/库房名称" value-key="id">
              <el-option v-for="item in nameOptions[form.settlementType]" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商类型：" prop="supplierType">
            <el-select v-model="form.supplierType" @change="handleChangeType" size="mini" filterable style="width: 100%" placeholder="请选择供应商类型">
              <el-option label="公路" value="1" />
              <el-option label="水路" value="2" />
              <el-option label="港口及其他" value="3" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供应商：" prop="supplierId" ref="supplier">
            <el-select v-model="form.supplierId" size="mini" filterable style="width: 100%" placeholder="请选择供应商" value-key="supplier_id" @change="supplierChange">
              <el-option v-for="item in supplierOptions" :key="item.supplier_id" :label="item.supplier_name" :value="item.supplier_id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="作业类型：" prop="taskTypeId">
            <el-select v-model="form.taskTypeId" size="mini" filterable style="width: 100%" placeholder="请选择作业类型" value-key="id">
              <el-option v-for="item in taskTypeOptions[form.settlementType === 0 ? 'warehouseWork' : form.settlementType === 1 ? 'portWork' : '']" :key="item.id" :label="item.classaName" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="作业时间：" prop="taskTime">
            <el-date-picker v-model="form.taskTime" style="width: 100%" size="mini" type="date" value-format="yyyy-MM-dd" placeholder="请选择作业时间"> </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="面积：" prop="square">
            <el-input v-model="form.square" size="mini" type="number" :disabled="true" placeholder="请输入面积" />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="dialogTitle === '修改'">
          <el-form-item label="品牌：" prop="brandId">
            <el-select v-model="form.brandId" size="mini" filterable style="width: 100%" placeholder="请选择品牌" value-key="id">
              <el-option v-for="listItem in brandOptions" :key="listItem.id" :label="listItem.brand" :value="listItem.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="dialogTitle === '修改'">
          <el-form-item label="委托商数量：" prop="customerTaskNum" :rules="form.customerId ? rules.customerTaskNum : [{ required: false }]">
            <el-input v-model="form.customerTaskNum" size="mini" type="number" :disabled="form.customerId ? false : true" :placeholder="form.customerId ? '请输入委托商数量' : '请选择委托商'" />
          </el-form-item>
          <el-form-item label="供应商数量：" prop="supplierTaskNum" :rules="form.supplierId ? rules.supplierTaskNum : [{ required: false }]">
            <el-input v-model="form.supplierTaskNum" size="mini" type="number" :disabled="form.supplierId ? false : true" :placeholder="form.supplierId ? '请输入供应商数量' : '请选择供应商'" />
          </el-form-item>
        </el-col>
      </el-row>
      <div-border label="品牌列表" v-if="dialogTitle === '新增'">
        <el-row v-for="(item, index) in form.brandAndNums" :gutter="10">
          <el-col :span="24">
            <i v-show="form.brandAndNums.length > 1" class="el-icon-error pointer right" @click="removeBrand(index)" />
          </el-col>
          <el-col :span="12">
            <el-form-item label="品牌：" :prop="`brandAndNums.${index}.brandId`" :rules="rules.brandId">
              <el-select v-model="item.brandId" size="mini" filterable style="width: 100%" placeholder="请选择品牌" value-key="id">
                <el-option v-for="listItem in brandOptions" :key="listItem.id" :label="listItem.brand" :value="listItem.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="margin-left: 20px">
            <div style="display: flex">
              <el-form-item label="委托商数量:" :prop="'brandAndNums[' + index + '].customerTaskNum'" :rules="isCustomer ? [{ validator: validateCustomer }] : []" :required="isCustomer">
                <el-input v-model="item.customerTaskNum" :disabled="form.customerId ? false : true" size="mini" type="number" :placeholder="form.customerId ? '请输入委托商数量' : '请选择委托商'" style="width: 150px" />
              </el-form-item>
              <el-form-item label="供应商数量:" :prop="'brandAndNums[' + index + '].supplierTaskNum'" :rules="isSupplier ? [{ validator: validateSupplier }] : []" :required="isSupplier">
                <el-input v-model="item.supplierTaskNum" :disabled="form.supplierId ? false : true" size="mini" type="number" :placeholder="form.supplierId ? '请输入供应商数量' : '请选择供应商'" style="width: 150px" />
              </el-form-item>
              <el-form-item label="" :prop="`brandAndNums.${index}.unit`" label-width="10px" :rules="rules.unit">
                <el-select v-model="item.unit" size="mini" filterable style="width: 150px" placeholder="请选择计量单位" value-key="id">
                  <el-option v-for="listItem in unitOptions" :key="listItem.id" :label="listItem.unit" :value="listItem.unit" />
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </div-border>
      <div class="teamAdd" v-if="dialogTitle === '新增'">
        <span>添加品牌：</span>
        <div class="add" @click="addBrand">+</div>
      </div>
      <div class="flex-center-center mt20">
        <el-button size="medium" class="searchBtn" :loading="submitLoading" @click="submit">确认 </el-button>
        <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import { getName, getSupplierById, getTaskType, portWarehouseCostAdd, portWarehouseCostUpdate } from '@/service/warehouse';
  import divBorder from '@/components/divBorder.vue';
  import { customerInfoSelectList } from '@/service/financial';
  import { getModelList, getUnitOfMeasurement } from '@/service/vehiclelog';
  import { paramCategoryPageList } from '@/service/basicfile';

  export default {
    name: 'portWarehouseChargesForm',
    components: { divBorder },
    data() {
      let validateSupplierOrCustomer = (rule, value, callback) => {
        if (!this.form.supplierId && !this.form.customerId) {
          callback(new Error('委托商和供应商必填一个'));
        } else {
          //任意值被填写，清除验证提示
          if (!this.form.supplierId || !this.form.customerId) {
            // this.$nextTick(() => {
            //   this.$refs.zhname.clearValidate()
            // })
            this.$refs.customer.clearValidate();
            this.$refs.supplier.clearValidate();
          }
          callback();
        }
      };
      return {
        dialogVisible: false,
        dialogTitle: '新增',
        defaultForm: {},
        supplierForm: {
          nameId: '',
          settlementType: 1, //暂时的
        },
        form: {
          customerId: '',
          supplierType: '',
          settlementType: '',
          nameId: '',
          supplierId: '',
          taskTypeId: '',
          taskTime: '',
          square: '',
          brandAndNums: [
            {
              brandId: '',
              customerTaskNum: '',
              supplierTaskNum: '',
              unit: '',
            },
          ],
        },
        rules: {
          settlementType: [
            {
              required: true,
              message: '请选择结算类型',
              trigger: 'blur',
            },
          ],
          brandId: [
            {
              required: true,
              message: '请选择品牌',
              trigger: 'blur',
            },
          ],
          nameId: [
            {
              required: true,
              message: '请选择港口/库房名称',
              trigger: 'blur',
            },
          ],
          // supplierId: [
          //   {
          //     required: true,
          //     validator:validateSupplierOrCustomer,
          //     trigger: 'blur',
          //   },
          // ],
          // customerId: [
          //   {
          //     required: true,
          //     validator:validateSupplierOrCustomer,
          //     trigger: 'blur',
          //   },
          // ],
          taskTypeId: [
            {
              required: true,
              message: '请选择作业类型',
              trigger: 'blur',
            },
          ],
          taskTime: [
            {
              required: true,
              message: '请选择作业时间',
              trigger: 'blur',
            },
          ],
          customerTaskNum: [
            {
              required: true,
              message: '请输入委托商数量',
              trigger: 'blur',
            },
          ],
          supplierTaskNum: [
            {
              required: true,
              message: '请输入供应商数量',
              trigger: 'blur',
            },
          ],
          square: [
            {
              required: false,
              message: '请输入面积',
              trigger: 'blur',
            },
          ],
          unit: [
            {
              required: true,
              message: '请选择计量单位',
              trigger: 'blur',
            },
          ],
        },
        isCustomer: false,
        isSupplier: false,
        submitLoading: false,
        customerOptions: [],
        supplierOptions: [],
        nameOptions: [],
        taskTypeOptions: {
          portWork: [], //港口
          warehouseWork: [], //仓库
        },
        brandOptions: [],
        unitOptions: [],
        settlementTypeOptions: [
          {
            label: '库房',
            value: 0,
          },
          {
            label: '港口',
            value: 1,
          },
        ],
      };
    },
    mounted() {
      this.getSelectedData();
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      customerChange() {
        if (this.form.customerId !== null) {
          this.isCustomer = true;
          this.isSupplier = false;
        }
      },
      supplierChange() {
        if (this.form.supplierId !== null) {
          this.isSupplier = true;
          this.isCustomer = false;
        }
      },
      removeBrand(index) {
        this.$confirm('确定要删除当前品牌吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          if (this.form.brandAndNums.length && this.form.brandAndNums.length > 1) this.form.brandAndNums.splice(index, 1);
        });
      },
      addBrand() {
        let flag = false;
        if (this.form.brandAndNums && this.form.brandAndNums.length > 0) {
          this.form.brandAndNums.forEach(item => {
            for (const itemKey in item) {
              if (!item[itemKey] || item[itemKey] === '') flag = true;
            }
          });
        }
        // if (flag) return this.$message.warning('请选择品牌并输入作业数量后添加品牌！');
        this.form.brandAndNums.push({
          brandId: '',
          customerTaskNum: '',
          supplierTaskNum: '',
        });
      },
      emptySubordinates() {
        this.form.nameId = '';
        this.form.supplierId = '';
        this.form.taskTypeId = '';
        this.form.square = 0;
      },
      getSelectedData() {
        this.getCustomerInfoSelectList();
        this.getBrand();
        this.getName();
        this.getTaskType();
        this.getUnitOfMeasurement();
      },
      // 获取委托商
      async getCustomerInfoSelectList() {
        const { status, message, data } = await customerInfoSelectList();
        if (status !== 0) return this.$message.warning(message);
        this.customerOptions = data;
      },
      // 获取品牌
      async getBrand() {
        const { status, message, data } = await getModelList();
        if (status !== 0) return this.$message.warning(message);
        this.brandOptions = data;
      },
      // 获取计量单位
      async getUnitOfMeasurement() {
        const { status, message, data } = await getUnitOfMeasurement({ type: 1 });
        if (status !== 0) return this.$message.warning(message);
        this.unitOptions = data;
      },
      // 获取库房/港口
      async getName() {
        const { status, message, data } = await getName();
        if (status !== 0) return this.$message.warning(message);
        this.nameOptions = data;
      },
      async handleChangeType(type) {
        const { status, message, data } = await getSupplierById({ supplierType: type });
        if (status !== 0) return this.$message.warning(message);
        this.supplierOptions = data;
      },
      // 通过 库房/港口ID 获取供应商
      async getSupplier(flag) {
        this.supplierForm.nameId = this.form.nameId;
        const { status, message, data } = await getSupplierById(this.supplierForm);
        if (status !== 0) return this.$message.warning(message);
        this.supplierOptions = data;
        if (flag) {
          this.form.square = this.supplierOptions[0].square || 0;
        }
      },
      // 获取任务类型
      async getTaskType() {
        let portWork = await paramCategoryPageList({
          value: '',
          status: '',
          rows: 9999,
          Page: 1,
          classaName: '',
          states: '',
          paramId: 'f4c498ad4042497da07f30103b33c11c', //港口
        });

        let warehouseWork = await paramCategoryPageList({
          value: '',
          status: '',
          rows: 9999,
          Page: 1,
          classaName: '',
          states: '',
          paramId: 'fbb12ba50bab4a7dba2a83bb4c94a709', //仓库
        });
        if (portWork.status !== 0) return this.$message.warning(portWork.message);

        this.taskTypeOptions = { portWork: portWork.data.records, warehouseWork: warehouseWork.data.records };
      },
      dialogOpen(title, row) {
        this.dialogTitle = title;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        if (row) {
          this.form = row;
          this.getSupplier();
        }
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            let data;
            if (this.form.id) {
              this.form.brandAndNums = [];
              const brandAndNum = [
                {
                  brandId: this.form.brandId,
                  customerTaskNum: this.form.customerTaskNum ? String(this.form.customerTaskNum) : '',
                  supplierTaskNum: this.form.supplierTaskNum ? String(this.form.supplierTaskNum) : '',
                },
              ];
              this.form.brandAndNums.push(brandAndNum);
              let obj = {
                id: this.form.id,
                customerId: this.form.customerId,
                settlementType: this.form.settlementType,
                nameId: this.form.nameId,
                supplierId: this.form.supplierId,
                taskTypeId: this.form.taskTypeId,
                taskTime: this.form.taskTime,
                square: this.form.square,
                brandAndNums: brandAndNum,
              };
              data = await portWarehouseCostUpdate(obj);
            } else {
              data = await portWarehouseCostAdd(this.form);
              console.log(this.form);
            }
            if (data.status !== 0) return this.$message.warning(data.message);
            this.$message.success(data.message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
      //表单校验
      validateCustomer(rule, value, callback) {
        if (value === '' && this.isCustomer) {
          callback(new Error('请输入委托商数量'));
        } else {
          callback();
        }
      },
      validateSupplier(rule, value, callback) {
        if (value === '' && this.isSupplier) {
          callback(new Error('请输入供应商数量'));
        } else {
          callback();
        }
      },
      // getCustomerRules(fieldName) {
      //   return this.isCustomer ? [
      //     {
      //       validator: (rule, value, callback) => {
      //         if (value === '' || value === null || value === undefined) {
      //           callback(new Error('请输入委托商数量'));
      //         } else {
      //           callback();
      //         }
      //       },
      //       trigger: 'blur',
      //     },
      //   ] : [];
      // },
      // getSupplierRules(fieldName) {
      //   return this.isSupplier ? [
      //     {
      //       validator: (rule, value, callback) => {
      //         if (value === '' || value === null || value === undefined) {
      //           callback(new Error('请输入供应商数量'));
      //         } else {
      //           callback();
      //         }
      //       },
      //       trigger: 'blur',
      //     },
      //   ] : [];
      // },
    },
  };
</script>

<style lang="scss" scoped>
  .team {
    &Add {
      display: flex;
      align-items: center;
      margin: 20px 0;

      .add {
        width: 20px;
        height: 20px;
        padding-bottom: 3px;
        background-color: #999;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        margin-right: 15px;

        &:hover {
          cursor: pointer;
        }
      }

      span {
        font-size: 14px;
        color: #606266;
        font-weight: 700;
      }
    }

    &Item {
      display: flex;
      align-items: center;
      color: #999;
      font-size: 14px;
      margin-top: 10px;
      padding-bottom: 10px;

      span {
        margin-left: 5px;
        color: #606266;
        font-weight: 700;
      }

      border-bottom: 1px solid #cbcbcb;
    }
  }

  .transport {
    padding: 10px 5px;
  }
</style>
